var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.52081 14.5711L1.15685 8.20716C0.766321 7.81664 0.766321 7.18347 1.15685 6.79295L7.52081 0.428985C7.91133 0.0384603 8.5445 0.0384603 8.93502 0.428985C9.32554 0.819509 9.32554 1.45267 8.93502 1.8432L4.27817 6.50005L15.864 6.50005L15.864 8.50005L4.27817 8.50005L8.93502 13.1569C9.32554 13.5474 9.32554 14.1806 8.93502 14.5711C8.5445 14.9616 7.91133 14.9616 7.52081 14.5711Z","fill":"currentColor"}));
}

ArrowLeft.defaultProps = {"aria-hidden":"true","viewBox":"0 0 16 15","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
